/*
    © 2021 EcomGraduates
*/

// Define los selectores para mobile y desktop
const hiddenProductsMobile = document
  .querySelector("#predictive-search-input-mobile")
  .dataset.hiddenProducts.replace(/\s+/g, "")
  .split(",");
const hiddenProductsDesktop = document
  .querySelector("#predictive-search-input-desktop")
  .dataset.hiddenProducts.replace(/\s+/g, "")
  .split(",");
let swiperInstance = null;

const swiperInit = (amountProducts) => {
  if(swiperInstance){
    swiperInstance.destroy();
  }

  if (window.innerWidth < 769) {
    swiperInstance = new Swiper(".searchResultsMobile", {
      navigation: amountProducts > 2 ? {
        nextEl: ".swiper-button-next-mob",
        prevEl: ".swiper-button-prev-mob",
      } : false,
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: "row",
      },
      spaceBetween: 16,
      loop: false,
      allowTouchMove: amountProducts > 2,
    });

    if (amountProducts <= 2) {
      document.querySelectorAll(".swiper-header-arrows-mob")[1].style.display = "none";
    } else {
      document.querySelectorAll(".swiper-header-arrows-mob")[1].style.display = "flex";
    }

  } else {
    swiperInstance = new Swiper(".searchResultsDesktop", {
      navigation: amountProducts > 4 ? {
        nextEl: ".swiper-button-next-deskt",
        prevEl: ".swiper-button-prev-deskt",
      } : false,
      slidesPerView: 4,
      spaceBetween: 16,
      loop: false,
      allowTouchMove: amountProducts > 4,
    });

    if (amountProducts <= 4) {
      document.querySelector(".swiper-button-next-deskt").style.display = "none";
      document.querySelector(".swiper-button-prev-deskt").style.display = "none";
    } else {
      document.querySelector(".swiper-button-next-deskt").style.display = "flex";
      document.querySelector(".swiper-button-prev-deskt").style.display = "flex";
    }
  }
};



// Función para manejar el cambio de entrada
function handleInputChange(
  hiddenProducts,
  inputSelector,
  listSelector,
  modalFooterSelector
) {
  let modalFooter = document.querySelector(modalFooterSelector);
  let topSuggestionsElement;
  let searchResultsHeading;
  if (window.innerWidth < 769) {
    topSuggestionsElement = document.querySelector("#top-suggestions-menu-mobile");
    searchResultsHeading = document.querySelector("#search-results-heading-mobile");
  } else {
    topSuggestionsElement = document.querySelector("#top-suggestions-menu-desktop");
    searchResultsHeading = document.querySelector("#search-results-heading-desktop");
  }
  let swiperWrapper = document
    .querySelector(listSelector)
    .querySelector(".swiper-wrapper");
  document.querySelector(inputSelector)?.addEventListener(
    "input",
    window.debounce((e) => {
      const list = document.querySelector(listSelector);
      if (e.target.value.length === 0) {
        list.parentElement.style.display = "none";
        topSuggestionsElement.style.display = "block";
        if (modalFooter) {
          modalFooter.style.display = "none";
        }
      } else {
        fetch(
          `/search/suggest.json?q=${e.target.value}&resources[type]=product&resources[limit]=${e.target.dataset.limit}&resources[options][unavailable_products]=last`
        )
          .then((response) => response.json())
          .then((data) => {
            const products = data.resources.results.products;
            if (products.length > 0) {
              let html = "";
              let count = 0;
              products.forEach((product, index) => {
                let difference = product.compare_at_price_min - product.price;
                if (!hiddenProducts.includes(product.id.toString()) && !product.tags.includes('hide')) {
                  count ++;
                  html += `
                                    <div class="swiper-slide">
                                        <div class="Details_with_products_innerright_innerboxs_innerinfo_new">
                                            <div class="grid__item grid-product">
                                                <div class="grid-product__content">
                                                    <div class="grid__item-image-wrapper">        
                                                    <div class="grid__item-image-wrapper_top_new">
                                                        <a href="${
                                                          product.url
                                                        }" class="grid_product_link_new"></a>
                                                        <div class="grid-product__image-mask">
                                                        <div class="grid-product__image-mask_inner_new">
                                                            <div class="grid__image-ratio" style="--aspect-ratio:1;">
                                                            <img class="img-fluid lazyload static_image_new"
                                                                src="${
                                                                  product
                                                                    .featured_image
                                                                    .url
                                                                }"
                                                                data-src="${
                                                                  product
                                                                    .featured_image
                                                                    .url
                                                                }"
                                                                alt="${
                                                                  product
                                                                    .featured_image
                                                                    .alt
                                                                }"
                                                                width="100%"
                                                                height="auto"
                                                                loading="lazy"
                                                            >
                                                            </div>
                                                            ${
                                                              difference > 0
                                                                ? ` 
                                                            <div class="grid-product__save_new">
                                                                <p>Save $${difference}</p>
                                                            </div>
                                                            `
                                                                : ""
                                                            }
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div class="grid-product__meta">
                                                        <div class="product-title-wrapper mb-2 mt-2 d-flex">
                                                            <h3 class="product-title h6 w-100">
                                                            <a class="text-decoration-none d-block text-body fs-loretta h6 mb-0" href="${
                                                              product.url
                                                            }">
                                                                ${product.title}
                                                            </a>
                                                            </h3>
                                                            <h3 class="product-price text-price h6">
                                                            <span
                                                                class="product-price-final text-primary"
                                                                data-product-id="${
                                                                  product.id
                                                                }">
                                                                <span data-role='price' data-variant="without-currency">
                                                                ${window.formatMoney(
                                                                  product.price
                                                                )}
                                                                </span>
                                                            </span>
                                                            <s
                                                                class="product-price-compare mr-2 ${
                                                                  product.compare_at_price_min >
                                                                  product.price
                                                                    ? ""
                                                                    : "d-none"
                                                                }"
                                                                data-product-id="${
                                                                  product.id
                                                                }"
                                                                data-price-variant="compare-at"
                                                            >
                                                                <span class="visually-hidden">
                                                                ${
                                                                  e.target
                                                                    .dataset
                                                                    .textOldPrice
                                                                }
                                                                </span>
                                                                <span data-role='price' data-variant="without-currency">
                                                                ${window.formatMoney(
                                                                  product.compare_at_price_min
                                                                )}
                                                                </span>
                                                            </s>
                                                            </h3>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            `;
                }
              });
              searchResultsHeading.innerText = `Search results (${count})`;
              if (swiperWrapper) {
                swiperWrapper.innerHTML = html;
              } else {
                list.innerHTML = html;
              }
              list.parentElement.style.display = "block";
              topSuggestionsElement.style.display = "none";
              swiperInit(products.length);
            } else {
              list.parentElement.style.display = "none";
              topSuggestionsElement.style.display = "block";
            }

            if (modalFooter) {
              if (products.length === Number(e.target.dataset.limit)) {
                modalFooter.style.display = "block";
              } else {
                modalFooter.style.display = "none";
              }
            }
          });
      }
    }, 200)
  );
}

// Maneja el cambio de entrada para mobile
handleInputChange(
  hiddenProductsMobile,
  "#predictive-search-input-mobile",
  "#predictive-search-list-mobile",
  "#modal-search-mobile .modal-footer"
);

// Maneja el cambio de entrada para desktop
handleInputChange(
  hiddenProductsDesktop,
  "#predictive-search-input-desktop",
  "#predictive-search-list-desktop",
  "#modal-search-desktop .modal-footer"
);

// Handle "View all results" button for mobile
// document.querySelector('#predictive-search-btn-more-mobile').addEventListener('click', (e) => {
//     const q = document.querySelector('#predictive-search-input-mobile').value;
//     window.location.href = e.target.dataset.searchRouteUrl + `?q=${q}`;
// });

// // Handle "View all results" button for desktop
// document.querySelector('#predictive-search-btn-more-desktop').addEventListener('click', (e) => {
//     const q = document.querySelector('#predictive-search-input-desktop').value;
//     window.location.href = e.target.dataset.searchRouteUrl + `?q=${q}`;
// });
